import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class SelectableRow extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mouseOver: false,
    };
  }

  getColor() {
    const { selected } = this.props;
    const { mouseOver } = this.state;
    if (selected) {
      return 'rgba(0,0,0,.1)';
    }
    if (mouseOver) {
      return 'rgba(0,0,0,.05)';
    }
    return 'rgba(0,0,0,0)';
  }

  renderToolTip = () => {
    const { selected } = this.props;
    return (
      <Tooltip>
        Click to
        {selected ? ' unselect' : ' select'}
      </Tooltip>
    );
  }

  renderChildren = () => {
    const { children } = this.props;
    return React.Children.map(children, (child) => React.cloneElement(child, {
      onMouseOver: () => this.setState({ mouseOver: true }),
      onFocus: () => this.setState({ mouseOver: true }),
      onMouseOut: () => this.setState({ mouseOver: false }),
      onBlur: () => this.setState({ mouseOver: false }),
      style: { backgroundColor: this.getColor() },
    }));
  }

  render() {
    const { selected, onSelectChange, rowId } = this.props;

    return (
      <OverlayTrigger placement="top" overlay={this.renderToolTip()}>
        <tr
          onClick={() => onSelectChange(selected ? undefined : rowId)}
          onMouseOver={() => this.setState({ mouseOver: true })}
          onFocus={() => this.setState({ mouseOver: true })}
          onMouseOut={() => this.setState({ mouseOver: false })}
          onBlur={() => this.setState({ mouseOver: false })}
          style={{ backgroundColor: this.getColor() }}
        >
          {this.renderChildren()}
        </tr>
      </OverlayTrigger>
    );
  }
}

SelectableRow.propTypes = {
  selected: PropTypes.bool,
  onSelectChange: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  rowId: PropTypes.number.isRequired,
};

SelectableRow.defaultProps = {
  selected: false,
  children: undefined,
};

export default SelectableRow;
